import {
  createNativeStackNavigator,
  NativeStackScreenProps,
} from '@react-navigation/native-stack';
import { ICONS } from 'components/Icon';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';

import * as React from 'react';
import { ImageSourcePropType, View } from 'react-native';
import { SyncIndicator } from 'screens/SyncScreen/SyncIndicator';

import { PageStack } from 'screens/ReportingTab/PageStack';

const Stack = createNativeStackNavigator();
type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ROOT],
  Screens.RootPage
>;

const tabItems: {
  key: Screens.TAB_HOME;
  name: string;
  component: React.FC;
  icon: ICONS;
  nativeIcon: ImageSourcePropType;
}[] = [
  {
    key: Screens.TAB_HOME,
    name: 'Home',
    component: PageStack,
    icon: ICONS.HouseSolid,
    nativeIcon: require('assets/menu/HouseSolid.png'),
  },
];

export const HomeWithSidebar: React.FC<Props> = () => {
  return (
    <View style={{ flex: 1 }}>
      <Stack.Navigator
        initialRouteName={tabItems[0]?.key}
        screenOptions={{
          headerShown: false,
        }}
      >
        {tabItems.map((tabItem) => (
          <Stack.Screen
            key={tabItem.key}
            name={tabItem.key}
            component={tabItem.component}
          />
        ))}
      </Stack.Navigator>
      <SyncIndicator showSyncIcon />
    </View>
  );
};
